import React from 'react';
import { motion } from 'framer-motion';
import { FaPlay, FaApple, FaTrophy, FaFire, FaStar } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const scrollToDownload = () => {
    const element = document.getElementById('download');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="floating-shapes">
          <motion.div 
            className="shape shape-1"
            animate={{
              y: [0, -20, 0],
              rotate: [0, 180, 360],
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          <motion.div 
            className="shape shape-2"
            animate={{
              y: [0, 30, 0],
              rotate: [0, -180, -360],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          <motion.div 
            className="shape shape-3"
            animate={{
              y: [0, -40, 0],
              x: [0, 20, 0],
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </div>
      </div>
      
      <div className="container">
        <motion.div 
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div 
            className="hero-badge"
            variants={itemVariants}
          >
            <span className="badge-text">🌟 Level Up Your Skincare Game</span>
          </motion.div>
          
          <motion.h1 
            className="hero-title"
            variants={itemVariants}
          >
            Turn Skincare Into
            <span className="gradient-text"> An Adventure</span>
          </motion.h1>
          
          <motion.p 
            className="hero-description"
            variants={itemVariants}
          >
            Gamify your daily skincare routine with streaks, achievements, and level progression. Track your glow-up journey with personalized routines and unlock rewards as you build healthy habits.
          </motion.p>
          
          <motion.div 
            className="hero-buttons"
            variants={itemVariants}
          >
            <motion.button 
              className="btn btn-primary"
              onClick={scrollToDownload}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaApple />
              Download for iOS
            </motion.button>
            
            <motion.button 
              className="btn btn-secondary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPlay />
              Watch Demo
            </motion.button>
          </motion.div>
          
          <motion.div 
            className="hero-stats"
            variants={itemVariants}
          >
            <div className="stat">
              <div className="stat-number">25K+</div>
              <div className="stat-label">Glowing Users</div>
            </div>
            <div className="stat">
              <div className="stat-number">4.8★</div>
              <div className="stat-label">App Store Rating</div>
            </div>
            <div className="stat">
              <div className="stat-number">1M+</div>
              <div className="stat-label">Routines Completed</div>
            </div>
          </motion.div>
        </motion.div>
        
        <motion.div 
          className="hero-visual"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <div className="phone-mockup">
            <div className="phone-frame">
              <div className="phone-screen">
                <div className="app-preview">
                  <div className="skincare-dashboard">
                    <div className="user-level">
                      <div className="level-badge">
                        <FaTrophy className="trophy-icon" />
                        <span className="level-text">Level 12</span>
                      </div>
                      <div className="progress-bar">
                        <div className="progress-fill" style={{width: '75%'}}></div>
                      </div>
                    </div>
                    <div className="streak-counter">
                      <FaFire className="fire-icon" />
                      <span className="streak-number">7</span>
                      <span className="streak-label">Day Streak</span>
                    </div>
                    <div className="routine-card">
                      <div className="routine-header">
                        <span className="routine-time">Morning Routine</span>
                        <FaStar className="star-icon" />
                      </div>
                      <div className="routine-steps">
                        <div className="step completed">✓ Cleanser</div>
                        <div className="step completed">✓ Toner</div>
                        <div className="step active">• Serum</div>
                        <div className="step">• Moisturizer</div>
                        <div className="step">• Sunscreen</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
